import {Component, Input, OnInit} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {IconComponent} from '../../icons-svgs/icons-svgs.component';
import {AccomRoomspecComponent} from '../accom-roomspec/accom-roomspec.component';
import {NgClass, NgFor, NgIf} from '@angular/common';

@Component({
    selector: 'app-accommodation-features',
    templateUrl: './accommodation-features.component.html',
    styleUrls: ['./accommodation-features.component.scss'],
    standalone: true,
  imports: [NgIf, AccomRoomspecComponent, IconComponent, NgClass, NgFor, TranslateModule,]
})
export class AccommodationFeaturesComponent implements OnInit {

  // @ TODO : il doit y avoir moyen d'optimiser le composant

  /**
   * amenities_1 -> features of the room. Type: Array
   * amenities_2 -> features of the house. Type: Array
   * type        -> use for the id & define what's display. Type : string
   */
  @Input() amenities_1 = [];
  @Input() amenities_2 = [];
  @Input() type;
  @Input() room;
  @Input() isLoading = false;
  @Input() page:string;

  isMobile: boolean;
  public basisNotIncluded: { name: string, icon: string }[] = [];

  constructor(
    private mobileDetector: DeviceDetectorService,
    private translateService: TranslateService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit(): void {
    this.isMobile = this.mobileDetector.isMobile();
    this.checkBasicsAmenities();
  }

  gotoHelpCenter() {
    if (this.translateService.currentLang == 'fr') {
      window.open('https://help.livin-france.com/knowledge/il-est-inscrit-provisions-sur-charges-dans-mon-contrat-quest-ce-que-cela-signifie', '_blank', 'noopener,noreferrer');
    } else {
      window.open('https://help.livin-france.com/en/knowledge/my-charges-are-provisions-sur-charges-what-does-it-means', '_blank', 'noopener,noreferrer');
    }
  }

  private checkBasicsAmenities() {
    let hasBedLinen = null;
    let hasPillow = null;
    let hasDuvet = null;
    if (this.amenities_1 && this.amenities_1.length > 0) {
      hasBedLinen = this.amenities_1.some(am => am.description === 'Bed Linen' || am.title === 'Bed Linen');
      hasPillow = this.amenities_1.some(am => am.description === 'Pillow' || am.title === 'Pillow');
      hasDuvet = this.amenities_1.some(am => am.description === 'Duvet' || am.title === 'Duvet');
    }
    if (this.amenities_2 && this.amenities_2.length > 0) {
      if (!hasBedLinen) {
        hasBedLinen = this.amenities_2.some(am => am.description === 'Bed Linen' || am.title === 'Bed Linen');
      }
      if (!hasPillow) {
        hasPillow = this.amenities_2.some(am => am.description === 'Pillow' || am.title === 'Pillow');
      }
      if (!hasDuvet) {
        hasDuvet = this.amenities_2.some(am => am.description === 'Duvet' || am.title === 'Duvet');
      }
    }

    if (!hasBedLinen) {
      this.basisNotIncluded.push({name: 'BED LINEN', icon: 'Sheets'});
    }
    if (!hasPillow) {
      this.basisNotIncluded.push({name: 'PILLOW', icon: 'pillow'});
    }
    if (!hasDuvet) {
      this.basisNotIncluded.push({name: 'DUVET', icon: 'Sheets'});
    }
  }

  goToInsuranceHelpCenter() {
    if (this.translateService.currentLang == 'fr') {
      window.open('https://help.livin-france.com/knowledge/definition-assurance-habitation', '_blank')
    } else {
      window.open('https://help.livin-france.com/en/knowledge/what-is-housing-insurance', '_blank')
    }
  }

  openModal(content){
    this.modalService.open(content, {size: 'xl', centered: true,backdropClass:'opacity-1'});
  }


}
